export const BASE_URL = CONFIG.API_BASE_URL;
export const GATEWAY_URL = CONFIG.API_GATEWAY_URL;
export const CAPTCHA_URL = CONFIG.CAPTCHA_URL;

export const API_URL = `${BASE_URL}`;
export const API_GATEWAY_URL = GATEWAY_URL;

export const HUBSPOT_PORTAL_ID = CONFIG.HUBSPOT_PORTAL_ID;
export const HUBSPOT_FORM_GUID = CONFIG.HUBSPOT_FORM_GUID;
export const RAPNET_TERMS_LINK =
  'https://rapaport.com/wp-content/uploads/2026/05/Rapaport-Trade-Member-License-Agreement.pdf';
export const PRICE_LIST_TERMS_LINK =
  'https://rapaport.com/wp-content/uploads/2026/05/Rapaport-Trade-Member-License-Agreement.pdf';
export const PRIVACY_POLICY_LINK =
  'https://rapaport.com/wp-content/uploads/2026/05/RAPAPORT-PRIVACY-POLICY-Update-May-19-2026.pdf';
